import { useMemo } from 'react'
import { useWindowSize } from '~/utils'

interface IProviIcon {
  color?: string
  hideOnDesktop?: boolean
}

export const ProviIcon = ({ color, hideOnDesktop }: IProviIcon) => {
  const { width } = useWindowSize() || { width: 1280 }
  const isDesktop = useMemo(() => (width && width > 800) || false, [width])

  if (isDesktop && hideOnDesktop) {
    return null
  }

  return (
    <svg width="81" height="24" viewBox="0 0 81 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.0774 4.13655C16.4593 -1.16291 8.40583 -1.37039 3.51735 3.51409C1.15404 5.87639 -0.0171395 8.97916 0.00190404 12.0762L0 12.0743V24H11.9308L11.9289 23.9981C15.2577 24.019 18.5941 22.6675 21.0108 19.9378C24.9699 15.4664 25.0004 8.63652 21.0774 4.13655ZM15.2272 15.219C13.4486 16.9969 10.5654 16.9969 8.7867 15.219C7.00803 13.4411 7.00803 10.5591 8.7867 8.78119C10.5654 7.00328 13.4486 7.00328 15.2272 8.78119C17.0059 10.5591 17.0059 13.4411 15.2272 15.219Z"
        fill={color || 'white'}
      />
      <path
        d="M39.228 12.5556C39.228 16.1435 36.6279 18.9129 33.474 18.9129C31.8599 18.9129 30.6798 18.359 29.8861 17.4435V23.3916H26.2735V6.53709H29.8861V7.66961C30.6798 6.75408 31.8599 6.20019 33.474 6.20019C36.6279 6.19829 39.228 8.96771 39.228 12.5556ZM35.6153 12.5556C35.6153 10.7493 34.4105 9.61867 32.7507 9.61867C31.0891 9.61867 29.8861 10.7512 29.8861 12.5556C29.8861 14.3619 31.091 15.4925 32.7507 15.4925C34.4124 15.4925 35.6153 14.36 35.6153 12.5556Z"
        fill={color || 'white'}
      />
      <path
        d="M48.4974 6.29536V10.3876C47.0052 10.1478 44.8867 10.7493 44.8867 13.1323V18.5741H41.2741V6.53518H44.8867V8.6784C45.3664 7.06433 46.9804 6.29536 48.4974 6.29536Z"
        fill={color || 'white'}
      />
      <path
        d="M49.2188 12.5556C49.2188 8.96771 52.0587 6.20019 55.599 6.20019C59.1393 6.20019 61.9791 8.96962 61.9791 12.5556C61.9791 16.1435 59.1374 18.9129 55.599 18.9129C52.0606 18.911 49.2188 16.1416 49.2188 12.5556ZM58.3684 12.5556C58.3684 10.8464 57.1636 9.71384 55.599 9.71384C54.0344 9.71384 52.8296 10.8464 52.8296 12.5556C52.8296 14.2648 54.0344 15.3974 55.599 15.3974C57.1655 15.3955 58.3684 14.2648 58.3684 12.5556Z"
        fill={color || 'white'}
      />
      <path
        d="M75.2229 6.53518L70.769 18.5741H66.6767L62.2228 6.53518H66.2199L68.7247 14.1678L71.2296 6.53518H75.2229Z"
        fill={color || 'white'}
      />
      <path
        d="M76.186 3.30894C76.186 2.12884 77.1739 1.14288 78.3521 1.14288C79.5303 1.14288 80.52 2.12884 80.52 3.30894C80.52 4.48904 79.5322 5.4769 78.354 5.4769C77.1758 5.4769 76.186 4.48904 76.186 3.30894ZM76.5477 6.53518H80.1603V18.5741H76.5477V6.53518Z"
        fill={color || 'white'}
      />
    </svg>
  )
}
